import { formatDataValue } from 'utils/formatFns';

export const vehicleHoldsFields = {
  damageReleaseDate: {
    label: 'Damage Release Date',
    getValue: (data) => data?.generalInfo?.vehicleHolds?.damageHold?.holdReleaseDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  generalHoldReleaseDate: {
    label: 'General Hold Release Date',
    getValue: (data) => data?.generalInfo?.vehicleHolds?.generalHold?.holdReleaseDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  generalHoldStartDate: {
    label: 'General Hold Start Date',
    getValue: (data) => data?.generalInfo?.vehicleHolds?.generalHold?.holdStartDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  holdReleaseDate: {
    label: 'Hold Release Date',
    getValue: (data) => data?.generalInfo?.vehicleHolds?.generalHold?.holdReleaseDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  holdStartDate: {
    label: 'Hold Start Date',
    getValue: (data) => data?.generalInfo?.vehicleHolds?.generalHold?.holdStartDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  vehicleHoldType: {
    label: 'Type',
    getValue: (data) => ({
      holdCode: data?.generalInfo?.vehicleHolds?.generalHold?.holdCode,
      holdDescription: data?.generalInfo?.vehicleHolds?.generalHold?.holdDescription,
    }),
    formatValue: ({ holdCode, holdDescription }) => {
      const formattedCode = formatDataValue({ value: holdCode });
      const formattedDescription = formatDataValue({ value: holdDescription });
      return `${formattedCode} | ${formattedDescription}`;
    },
  },
};
